import React from "react";
import contact from "../Images/contactus.jpg";
export default function Contact() {
  return (
    <div>
      <section className="wrapper !bg-[#edf2fc]">
        <div className="container !pt-10 !pb-36 xl:!pt-[4.5rem] lg:!pt-[4.5rem] md:!pt-[4.5rem] xl:!pb-40 lg:!pb-40 md:!pb-40 !text-center">
          <div className="flex flex-wrap mx-[-15px]">
            <div className="md:w-10/12 lg:w-8/12 xl:w-8/12 w-full flex-[0_0_auto] px-[15px] max-w-full !mx-auto">
              <h1 className="text-[calc(1.365rem_+_1.38vw)] font-bold leading-[1.2] xl:text-[2.4rem] !mb-3">
                Contact Us
              </h1>
              <p className="lead lg:!px-[1.25rem] xl:!px-[1.25rem] xxl:!px-[2rem] leading-[1.65] text-[0.9rem] font-medium max-w-full">
                ECHS (Ex-Servicemen Contributory Health Scheme).
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="wrapper !bg-[#ffffff]   relative border-0 upper-end before:top-[-4rem] before:border-l-transparent before:border-r-[100vw] before:border-t-[4rem] before:border-[#fefefe] before:content-[''] before:block before:absolute before:z-0 before:border-y-transparent before:border-0 before:border-solid before:right-0">
        <div className="container pb-12">
          <div className="flex flex-wrap mx-[-15px] !mb-[4.5rem] md:!mb-24">
            <div className="xl:w-10/12 w-full flex-[0_0_auto] px-[15px] max-w-full !mx-auto mt-[-9rem]">
              <div className="card">
                <div className="flex flex-wrap mx-0">
                  <div className="xl:w-6/12 lg:w-6/12 w-full flex-[0_0_auto] max-w-full image-wrapper bg-image rounded-t-[0.4rem] rounded-lg-start hidden xl:block lg:block md:block bg-cover bg-[center_center] bg-no-repeat !bg-scroll md:min-h-[25rem]">
                    <img src={contact} />
                  </div>
                  <div className="xl:w-6/12 lg:w-6/12 w-full flex-[0_0_auto] max-w-full">
                    <div className="p-10 xl:!p-[4.5rem] lg:!p-[4.5rem] md:!p-12">
                      <div className="flex flex-row">
                        <div>
                          <div className="icon text-[#3f78e0] xl:text-[1.4rem] text-[calc(1.265rem_+_0.18vw)] !mr-4 mt-[-0.25rem]">
                            {" "}
                            <i className="uil uil-location-pin-alt before:content-['\ebd8']" />{" "}
                          </div>
                        </div>
                        <div className="!self-start !justify-start">
                          <h5 className="!mb-1">Address</h5>
                          <address className=" not-italic leading-[inherit] mb-4">
                            GX4H+53F,Vivekananda Nagar,Pangodu,{" "}
                            <br className="hidden xl:block lg:block md:block" />
                            Thiruvananthapuram
                          </address>
                        </div>
                      </div>
                      <div className="flex flex-row">
                        <div>
                          <div className="icon text-[#3f78e0] xl:text-[1.4rem] text-[calc(1.265rem_+_0.18vw)] !mr-4 mt-[-0.25rem]">
                            {" "}
                            <i className="uil uil-phone-volume before:content-['\ec50']" />{" "}
                          </div>
                        </div>
                        <div>
                          <h5 className="!mb-1">Phone</h5>
                          <p>0471 2354715</p>
                        </div>
                      </div>
                      <div className="flex flex-row">
                        <div>
                          <div className="icon text-[#3f78e0] xl:text-[1.4rem] text-[calc(1.265rem_+_0.18vw)] !mr-4 mt-[-0.25rem]">
                            {" "}
                            <i className="uil uil-envelope before:content-['\eac8']" />{" "}
                          </div>
                        </div>
                        <div>
                          <h5 className="!mb-1">E-mail</h5>
                          <p className="!mb-0">
                            <a
                              href="mailto:shqtrivandrum@echs.gov.in"
                              className="text-[#60697b]"
                            >
                              shqtrivandrum@echs.gov.in
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
